import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#E3001B',
    primaryDark: '#A70014',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/euroassekuranz-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/euroassekuranz-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/euroassekuranz-logo.png',

    availableProducts: ["Haftpflichtschaden", "Kaskoschaden"],
});